import React from "react";

function Requests() {
    return (
        <div style={{textAlign: 'center', padding: '6rem', }}>
            <h1>Coming Soon</h1>
        </div>
    );
}
export default Requests